module.exports = __webpack_public_path__ + "d3b9c92c8d5644379eafb03cd438694e.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1128
// module chunks = 0